<template>
  <div>
    <div>
      <ul class="list breadcrumbs pl-0 fs-12 fw-700 lh-24 mt-0 ttc">
        <li class="dib">
          <!-- <a href="/"><span class="gray-dark">Home</span></a> -->
          <router-link :to="{ name: 'home' }"><span class="gray-dark">Home</span></router-link>
        </li>
        <li class="dib" v-for="(item, index) in breadcrumbs" :key="`${index}`">
          <template v-if="item.link">
            <!-- <a :href="item.link">
              <span class="gray-dark">{{ item.title }}</span>
            </a> -->
           <router-link :to="{ path: item.link }">
              <span class="gray-dark">{{ item.title }}</span>
            </router-link>
          </template>
          <template v-else>
            <span class="gray-dark">{{ item.title }}</span>
          </template>
        </li>
        <!--      <slot></slot>-->
      </ul>
    </div>
    <client-only>
      <Teleport to="head">
        <component :is="'script'" type="application/ld+json">
          {{ JSON.stringify(jsonLdContent) }}
        </component>
      </Teleport>
    </client-only>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useLocalDesignerStore } from '~/store/pinia/localDesigner'

export default {
  name: 'Breadcrumbs',
  props: {
    breadcrumbs: { type: Array },
  },
  setup(props) {
    const route = useRoute()
    const localDesignerStore = useLocalDesignerStore()
    const localDesigner = computed(() => localDesignerStore.designer)
    const jsonLdContent = computed(() => {
      if (props.breadcrumbs) {
        return {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              item: {
                '@id': useRuntimeConfig().public.publicDomain,
                name: 'Home',
              },
            },
            ...props?.breadcrumbs?.map((item, index) => {
              return {
                '@type': 'ListItem',
                position: index + 2,
                item: {
                  '@id': `${useRuntimeConfig().public.publicDomain}${item?.link}`,
                  name: index === 2 && route.name === 'local-designer' ? localDesigner.value?.full_name : item?.title,
                },
              }
            }),
          ],
        }
      }
      return {}
    })
    return { jsonLdContent }
  },
}
</script>

<style scoped lang="scss">
// v2 Link — linked crumbs green, no resting underline, hover → green-deep +
// underline; the last (current) crumb has no <a>, so it keeps its muted colour.
.breadcrumbs a {
  color: $link;
  text-decoration: none;
  transition: color $dur-fast $ease-out;
  @include focus-ring; // v2 §537 — green ring
  span { color: inherit; }
  &:hover { color: $link-strong; text-decoration: underline; } // v2 Link — green underline-on-hover (was gold)
}
.breadcrumbs li:first-child {
  padding-left: 0;
}
.breadcrumbs li:after {
  content: '';
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-left: 4px;
  margin-right: 6px;
  background-image: url('#{$assets-cdn}/icons/icon-arrow-next.svg');
  background-position: right center;
  background-size: contain;
  background-repeat: no-repeat;
}

.breadcrumbs li:last-child {
  padding-right: 0;
}
.breadcrumbs li:last-child:after {
  display: none;
}
</style>
